/**
 * 배너 오버레이 문구 폰트 — 배너가 실제로 렌더될 때만 Google Fonts 를 지연 로딩한다.
 * (보호자앱과 동일 키/패밀리를 사용해 미리보기와 실제 노출을 일치시킨다)
 */
export interface BannerFont {
  key: string;
  label: string;
  family: string;
  href: string | null; // null = 번들 기본(로드 불필요)
}

export const BANNER_FONTS: BannerFont[] = [
  {
    key: 'gothic',
    label: '기본 고딕',
    family: "'Pretendard Variable','Noto Sans KR',sans-serif",
    href: null,
  },
  {
    key: 'blackhan',
    label: '임팩트 (Black Han Sans)',
    family: "'Black Han Sans',sans-serif",
    href: 'https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap',
  },
  {
    key: 'jua',
    label: '둥근 친근 (Jua)',
    family: "'Jua',sans-serif",
    href: 'https://fonts.googleapis.com/css2?family=Jua&display=swap',
  },
  {
    key: 'dohyeon',
    label: '또렷 굵게 (Do Hyeon)',
    family: "'Do Hyeon',sans-serif",
    href: 'https://fonts.googleapis.com/css2?family=Do+Hyeon&display=swap',
  },
  {
    key: 'gamja',
    label: '손글씨 (Gamja Flower)',
    family: "'Gamja Flower',cursive",
    href: 'https://fonts.googleapis.com/css2?family=Gamja+Flower&display=swap',
  },
];

const byKey = (key?: string | null): BannerFont =>
  BANNER_FONTS.find(f => f.key === key) ?? BANNER_FONTS[0];

/** 폰트 키에 해당하는 font-family 를 반환하고, 필요하면 Google Fonts <link> 를 1회 주입한다. */
export function ensureBannerFont(key?: string | null): string {
  const f = byKey(key);
  if (typeof document !== 'undefined' && f.href) {
    const id = `bannerfont-${f.key}`;
    if (!document.getElementById(id)) {
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = f.href;
      document.head.appendChild(link);
    }
  }
  return f.family;
}
